import { render, staticRenderFns } from "./EditVariableExpense.vue?vue&type=template&id=0b834459"
import script from "./EditVariableExpense.vue?vue&type=script&lang=js"
export * from "./EditVariableExpense.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports